export const getBaseUrl = (
  api_host: string,
  corporate_admin_api_host?: string
): string => {
  return corporate_admin_api_host
    ? `https://${corporate_admin_api_host}`
    : `https://${api_host}`;
};
